import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'litmus-button',
    templateUrl: './litmus-button.component.html',
    styleUrls: ['./litmus-button.component.scss'],
    standalone: false
})
export class LitmusButtonComponent implements OnInit,OnChanges {
  @Input() text:string="Button";
  @Input() class_name:string="defalt-button";
  @Input() disabled:boolean=false
  @Output() click:any = new EventEmitter<any>();
  constructor(){}
  ngOnInit(): void {
    
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(!this.class_name || this.class_name == 'undefined'){
      this.class_name = "defalt-button";
    }
  }
  onClick(event:any){
    event.stopPropagation();
    this.click.emit();
  }
}
